module.exports = __webpack_public_path__ + "static/media/banner-slide-3.fca5bde3.jpg";